var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "Float"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeFloat) + " ")];
      },
      proxy: true
    }])
  }, [_c('b-card-text', [_vm._v("Using float utility classes:")]), _c('div', {
    staticClass: "clearfix"
  }, [_c('b-spinner', {
    staticClass: "float-right",
    attrs: {
      "label": "Floated Right"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }